import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

const YES_NO = 'YesNo';
const YES = 'YES';
const NO = 'NO';
const ON_OFF = 'OnOff';
const ON = 'ON';
const OFF = 'OFF';

const Switch = ({
                    disabled,
                    label,
                    labelAlignment,
                    onChange = () => {},
                    statusText,
                    ...props
                }) => {
    const [status, setStatus] = useState(props.status === true);
    const [mouseOver, setMouseOver] = useState(false);
    const statusTextOptions = [];
    statusTextOptions[YES_NO] = [YES, NO];
    statusTextOptions[ON_OFF] = [ON, OFF];
    const statusTexts = statusTextOptions[statusText];
    const getStatusText = () => (status ? statusTexts[0] : statusTexts[1]);

    useEffect(() => {
        setStatus(props.status);
    }, [props.status]);

    const labelAlign = () => {
        if (labelAlignment === 'left') return 'align-left';
        if (labelAlignment === 'right') return 'align-right';
        if (labelAlignment === 'top') return 'align-top';
    };

    const handleChange = () => {
        if (disabled) return;
        setStatus(!status);
        setMouseOver(false);
        onChange(status, { mouseOver, statusTexts });
        // return status === true;
    };

    const handleOnMouseOver = () => {
        setMouseOver(true);
    };

    const handleOnMouseOut = () => {
        setMouseOver(false);
    };

    const statusTextClassNames = () => {
        let classes = '';
        if (disabled === true) classes = ' disabled ';
        else if (status === true) classes = 'bold';
        return classes;
    };

    const getMouseOverClass = () => {
        const classPrefix = 'icon prism-icon-checkmark-circle';
        return mouseOver ? `${classPrefix} is-mouse-over` : classPrefix;
    };

    return (
        <div className={`switch ${labelAlign()}`}>
            <div className={`switch-label ${labelAlign()}`}>{label}</div>
            <div
                className="switch-clickable"
                onFocus={handleOnMouseOver}
                onBlur={handleOnMouseOut}
                onMouseOver={handleOnMouseOver}
                onMouseOut={handleOnMouseOut}
            >
                <label
                    aria-selected={status}
                    className={`switch-wrapper ${labelAlign()}`}
                >
                    <input
                        aria-label="checkbox"
                        disabled={disabled}
                        type="checkbox"
                        onChange={handleChange}
                        checked={status}
                    />
                    <span className="switch-track" onClick={handleChange} />
                    <span className={`switch-thumb ${getMouseOverClass()}`} onClick={handleChange} />
                </label>
                <label
                    role="status"
                    className={`switch-status-text ${statusTextClassNames()} ${labelAlign()}`}
                    onClick={handleChange}
                >
                    {getStatusText()}
                </label>
            </div>
        </div>
    );
};

const propTypes = {
    disabled: PropTypes.bool,
    label: PropTypes.string.isRequired,
    labelAlignment: PropTypes.oneOf(['top', 'left', 'right']).isRequired,
    onChange: PropTypes.func,
    status: PropTypes.bool,
    statusText: PropTypes.oneOf(['OnOff', 'YesNo']).isRequired,
};

const defaultProps = {
    labelAlignment: 'left',
    disabled: false,
    label: '',
    status: false,
    statusText: 'YesNo',
};

Switch.propTypes = propTypes;
Switch.defaultProps = defaultProps;

Switch.YES_NO = YES_NO;
Switch.YES = YES;
Switch.NO = NO;
Switch.ON_OFF = ON_OFF;
Switch.ON = ON;
Switch.OFF = OFF;

export default Switch;
